import {
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  GET_EVENT_DETAILS,
  GET_EVENT_DETAILS_SUCCESS,
  SET_EVENT_DETAILS_STATUS,
  API_ERROR,
  GET_PENALTIES,
  GET_PENALTIES_SUCCESS,
  GET_PENALTIES_ERROR,
  GET_EVENTS_LOCATIONS_SUCCESS,
  EVENTS_REFRESHED,
  EVENT_ANNOUNCEMENTS_REFRESHED,
} from "./actionTypes"

const initialState = {
  error: "",
  events: [],
  eventDetails: [],
  eventsLocations: [],
  penaltiesManager: [],
  penaltiesLoading: false,
  penaltiesError: false,
  loading: false,
}

const events = (state = initialState, action) => {
  switch (action.type) {
    case GET_EVENTS_LOCATIONS_SUCCESS:
      state = {
        ...state,
        eventsLocations: action?.payload,
      }
      break

    case GET_PENALTIES:
      state = {
        ...state,
        penaltiesQuery: JSON.stringify(action.payload),
        penaltiesLoading: true,
        penaltiesError: false,
      }
      break

    case GET_PENALTIES_SUCCESS:
      state = {
        ...state,
        penaltiesManager: action.payload,
        penaltiesLoading: false,
        penaltiesError: false,
      }
      break
    case GET_PENALTIES_ERROR:
      state = { ...state, penaltiesLoading: false, penaltiesError: true }
      break
    case GET_EVENTS:
      state = {
        ...state,
        loading: true,
        listLoading: true,
        listError: "",
      }
      break
    case GET_EVENTS_SUCCESS:
      state = {
        ...state,
        loading: false,
        listLoading: false,
        listError: "",
        events: action.payload,
      }
      break
    // A background read replaces the list, never its loading or error; the saga drops one that a newer read of the list overtook.
    case EVENTS_REFRESHED:
      state = { ...state, events: action.payload }
      break
    // A background read of an event's announcements replaces only them, and only while the page shows that event.
    case EVENT_ANNOUNCEMENTS_REFRESHED:
      if (state.eventDetails?.[0]?._id === action.id) {
        state = { ...state, eventDetails: state.eventDetails.map((event, index) => index === 0 ? { ...event, announcements: action.announcements } : event) }
      }
      break
    case GET_EVENT_DETAILS:
      state = {
        ...state,
        error: "",
        competitionReadError: null,
        loading: true,
      }
      break
    case GET_EVENT_DETAILS_SUCCESS:
      state = {
        ...state,
        error: "",
        competitionReadError: null,
        loading: false,
        eventDetails: action.payload,
      }
      break
    case SET_EVENT_DETAILS_STATUS:
      state = {
        ...state,
        eventDetails: state.eventDetails?.map((event, index) =>
          index === 0 ? { ...event, status: action.payload } : event
        ),
      }
      break
    case "EVENT_DIRECTORY_ERROR":
      state = { ...state, loading: false, listLoading: false, listError: action.payload }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false,
        competitionReadError: action.meta?.competitionRead || state.competitionReadError }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default events
